export const ENV_ZEPTO_DOMAIN = 'REACT_APP_ZEPTO_DOMAIN';
export const S3_ASSETS_URL = 'REACT_APP_S3_ASSETS_URL';
export const NODE_ENV = 'NODE_ENV';
export const PUBLIC_ASSETS_URL = 'REACT_APP_PUBLIC_ASSETS_URL';
export const APPLICATION_ID = 'REACT_APP_APPLICATION_ID';
export const PARENT_APPLICATION_ID = 'REACT_APP_PARENT_APPLICATION_ID';
export const BACKEND_URL = 'REACT_APP_BACKEND_URL';
export const ENV_MIXPANEL_PROJECT_KEY = 'MIXPANEL_PROJECT_KEY';
export const AUTH_BACKEND_URL = 'REACT_APP_AUTH_BACKEND_URL';
export const REACT_APP_NODE_ENV = 'REACT_APP_NODE_ENV';
export const REACT_APP_VENDOR_PORTAL_URL = 'REACT_APP_VENDOR_PORTAL_URL';
